module.exports = __webpack_public_path__ + "static/media/aubrey.c716a79a.jpg";